import _implicitStylesheets from "./faq.css";
import _implicitScopedStylesheets from "./faq.scoped.css?scoped=true";
import _wdsFormattedRichText from "wds/formattedRichText";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h2 class="axwp-faq__title${0}"${2}>${"t1"}</h2>`;
const $fragment2 = parseFragment`<summary${3}>${"t1"}<span aria-label="expand" class="axwp-faq__toggler collapsed${0}"${2}><svg aria-hidden="true" viewBox="0 0 52 52"${3}><path d="M30 29h16.5c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5H30c-.602 0-1-.398-1-1V5.5c0-.8-.7-1.5-1.5-1.5h-3c-.8 0-1.5.7-1.5 1.5V22c0 .602-.398 1-1 1H5.5c-.8 0-1.5.7-1.5 1.5v3c0 .8.7 1.5 1.5 1.5H22c.602 0 1 .398 1 1v16.5c0 .8.7 1.5 1.5 1.5h3c.8 0 1.5-.7 1.5-1.5V30c0-.602.398-1 1-1Zm0 0"${3}/></svg></span><span aria-label="collapse" class="axwp-faq__toggler expanded${0}"${2}><svg aria-hidden="true" viewBox="0 0 52 52"${3}><path d="M50 27.5c0 .8-.7 1.5-1.5 1.5h-45c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h45c.8 0 1.5.7 1.5 1.5Zm0 0"${3}/></svg></span></summary>`;
const $fragment3 = parseFragment`<hr class="axwp-faq__hr${0}"${2}>`;
const stc0 = {
  classMap: {
    "axwp-faq": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-faq__content": true
  },
  attrs: {
    "part": "content"
  },
  key: 3
};
const stc2 = {
  classMap: {
    "axwp-faq__single-content": true
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_element("div", stc1, api_iterator($cmp.options, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return [api_element("details", {
      attrs: {
        "open": it.first ? "" : null
      },
      key: api_key(4, it.value.title)
    }, [api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text(it.value.title))]), api_element("div", stc2, [api_custom_element("wds-formatted-rich-text", _wdsFormattedRichText, {
      props: {
        "value": it.value.body
      },
      key: 8
    })])]), api_static_fragment($fragment3, api_key(10, it.value.title))];
  }))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-14jbd258hbn";
tmpl.legacyStylesheetToken = "undefined-_faq";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
